import "./TimeSheetCategoryFieldsStyle.css";

import { CheckBox, Padding } from "@mui/icons-material";
import { Checkbox, Typography, useTheme } from "@mui/material";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity, EnhancedCheckboxRHF, EnhancedRadioGroupRHF, RHookFormTextField } from "@websential/cosmic-v20";
import { FC, useEffect, useRef, useState } from "react";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { TimeSheetCategoryFieldsHeader } from "../TimeSheetCategoryFieldsTable/TimeSheetCategoryFieldsTableHeader";

let columns = [
  { field: "title", headerName: "Title", },
  { field: "required", headerName: "Required", },
  { field: "status", headerName: "Status", },
  { field: "dataInput", headerName: "Data Input", },
];

let emptyCategoryFields = {
  id: null,
  title: null,
  required: false,
  status: 100,
  dataInput: 100,
}

let timeSheetTableDataInputDropDownField = [
  {
    label: "Drop Down",
    value: 100,
  },
  {
    label: "Text Field",
    value: 200,
  },
];
let timeSheetTableStatusDropDownField = [
  {
    label: "Active",
    value: 100,
  },
  {
    label: "Inactive",
    value: 200,
  },
];

interface ITimeSheetCategoryFieldsTable {
  categoryTableUpdatedData: (data: any) => void;
  categoryFieldsDataItems: any;
  onRowDeleteClicked: (data: any) => void;
  showIndexColumn: boolean,
}
export const TimeSheetCategoryFieldsTable: FC<
  ITimeSheetCategoryFieldsTable
> = ({ categoryTableUpdatedData, categoryFieldsDataItems, onRowDeleteClicked, showIndexColumn, }) => {

  const [categoryTable, setCategoryTable] = useState<any>(
    categoryFieldsDataItems
  );

  const [lastAddedRowId, setLastAddedRowId] = useState<any>(null);
  const [categoryFieldEmpty, setCategoryFieldEmpty] = useState(emptyCategoryFields);

  const newRowIds = useRef<Set<any>>(new Set());


  const hasNewRows = categoryTable?.some((row: any) =>
    newRowIds.current.has(row.id)
  );

  const hasApiRows = categoryTable?.some(
    (row: any) => row.categoryTrackingSave !== undefined
  );
  useEffect(() => {
    categoryTableUpdatedData(categoryTable);
  }, [categoryTable]);

  useEffect(() => {
    setCategoryTable(categoryFieldsDataItems);
    newRowIds.current = new Set();
    setLastAddedRowId(null);
  }, [categoryFieldsDataItems]);

  const findIndexById = (id: string | number | any) => {
    let index = -1;

    for (let i = 0; i < categoryTable.length; i++) {
      if (categoryTable[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return id;
  };

  const openNew = () => {
    // if (categoryTable && categoryTable.length >= 10) return null;
    let _categoryPanelData = [...categoryTable];
    let _categoryPanelNewRow: any = { ...categoryFieldEmpty };

    if (categoryFieldEmpty.id) {
      const rowIndex = findIndexById(categoryFieldEmpty.id);
      _categoryPanelData[rowIndex] = _categoryPanelNewRow;

    } else {
      const newRowId = createId();
      _categoryPanelNewRow.id = newRowId;

      newRowIds.current.add(newRowId);
      _categoryPanelData.push(_categoryPanelNewRow);
      setLastAddedRowId(newRowId && newRowId);
      console.log("New Row", newRowId);
      console.log("Rows", _categoryPanelData);
    }
    setCategoryTable(_categoryPanelData);
    setCategoryFieldEmpty(emptyCategoryFields);
  };

  // .string().email("Must be a valid email address")
  //  email: yup
  //     .string().email("Must be a valid email address")
  //     .test("email-test", "Email is required!", function (value) {
  //       const { role } = this.parent;

  //       if (hasRole(role, ROLE_TRANSMITTER)) {
  //         if (!value) {
  //           return this.createError({
  //             message: "Email is required!",
  //           });
  //         }
  //         if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
  //           return this.createError({
  //             message: "Please enter a valid email.",
  //           });
  //         }
  //       }
  //       return true;
  //     })
  //     .nullable(),
  // });
  const onCellValueChange = (event: any, rowIndex: number, field: any) => {

    setCategoryTable((prev: any) => {
      const updatedData = [...prev];

      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };

      updatedData[rowIndex] = updatedRow;
      return updatedData;
    });
  };

  const onDeleteNewAddedRow = (rowId: any) => {
    newRowIds.current.delete(rowId);
    setCategoryTable((prev: any[]) => {
      const rowDeleteBasedOnId = prev.filter((row) => row.id !== rowId);

      if (rowDeleteBasedOnId.length > 1) {
        const lastRowId = rowDeleteBasedOnId[rowDeleteBasedOnId.length - 1].id;
        setLastAddedRowId(lastRowId);
      } else {
        setLastAddedRowId(null);
      }
      return rowDeleteBasedOnId;
    });
  }

  const getRowDeleteHandler = (rowData: any) => {
    const isNewRow = newRowIds.current.has(rowData.id);

    if (isNewRow) {
      return () => onDeleteNewAddedRow(rowData.id);
    }

    if (rowData.categoryTrackingSave !== undefined) {
      return () => onRowDeleteClicked(rowData);
    }

    return null; // default rows → no icon
  };

  const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
    if (field.field === "title") {
      if (
        rowData.title !== "" &&
        rowData.title !== undefined &&
        rowData.title !== null
      ) {
        if (rowData.title === null) {
          return "p-component p-filled calender-error-input";
        } else if (rowData.title === "") {
          return "p-component p-filled calender-error-input";
        }
      }
    } else if (field.field === "title") {
      if (
        rowData.title !== "" &&
        rowData.title !== undefined &&
        rowData.title !== null
      ) {
        if (rowData.title === null) {
          return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
        } else if (rowData.title === "") {
          return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
        }
      } else {
        return "p-component p-filled input-dropdown-fields .p-dropdown";
      }
    } else {
      return "p-component p-filled input-dropdown-fields";
    }
  };
  const columnsBody = (rowData: any, row: any, x: any) => {
    if (x.field === "title") {
      return (
        <InputText
          value={rowData[x.field] ?? ""}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.target.value)}
          className={renderErrorClass(x, row.rowIndex, rowData)}
          style={{ borderRadius: "2px" }}
          disabled={rowData.categoryTrackingSave === true}
        />
      );
    } else if (x.field === "required") {
      return (
        <div style={{ display: "flex", justifyContent: "center", color: "#4b5563" }}>

          {/* <EnhancedCheckboxRHF
            name={!rowData.id ? `required_${rowData.title}` : `required_${rowData.id}`}
            checked={rowData.required ?? false}
            // onChange={(e: any) =>
            //   onCellValueChange(x, row.rowIndex, e.target.checked)
            // }
            testId="required"
          /> */}
          <Checkbox
            checked={rowData[x.field]}
            onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.target.checked)}
          />
        </div>
      );
    }
    else if (x.field === "status") {
      return (
        <Dropdown
          options={timeSheetTableStatusDropDownField}
          value={rowData[x.field] ?? 100}
          onChange={(e: any) =>
            onCellValueChange(x, row.rowIndex, e.target.value)
          }
          // placeholder="--"
          className={renderErrorClass(x, row.rowIndex, rowData)}
          optionLabel="label"
          optionValue="value"
          defaultValue={100}
          style={{ borderRadius: "2px", fontSize: "0.875rem" }}
        />
      );
    }
    else if (x.field === "dataInput") {
      return (
        <>
          <Dropdown
            options={timeSheetTableDataInputDropDownField}
            value={rowData[x.field] ?? 100}
            onChange={(e: any) =>
              onCellValueChange(x, row.rowIndex, e.target.value)
            }
            // placeholder="--"
            className={renderErrorClass(x, row.rowIndex, rowData)}
            optionLabel="label"
            optionValue="value"
            defaultValue={100}
            style={{ borderRadius: "2px", fontSize: "0.875rem" }}
          />

        </>
      );
    }
  };

  console.log("categoryTable", categoryTable)

  return (
    <>
      <div className="card">
        <TimeSheetCategoryFieldsHeader
          openNew={openNew}
        // selectedFieldPanelLabel={"Hello"}
        />
        <DataTable
          value={categoryTable}
          dataKey="id"
          key={lastAddedRowId}
          showGridlines
          className="TimeSheetCategoryFieldsStyle"
          editMode="cell"
          // resizableColumns
          columnResizeMode="expand"
          scrollable
          // reorderableColumns
          filterDisplay="menu"
          scrollHeight="416px"
        >
          {columns ? (
            <Column
              header="#"
              className="indexColumn"
              headerClassName="indexColumn"
              headerStyle={{ width: "24px" }}
              frozen
              hidden={!showIndexColumn}
              body={(data, options) => options.rowIndex + 1}
            ></Column>
          ) : undefined}

          {columns.map((x: any, index: any) => {
            return (
              <Column
                key={index}
                field={x.field}
                header={x.headerName}
                columnKey={x.field}
                style={{
                  fontSize: "0.875rem",
                }}
                body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
              />
            );
          })}
          {/* { <Column
            body={(rowData: any) => {
              const handler = getRowDeleteHandler(rowData);

              if (!handler) return null;

              const isDisabled = rowData.categoryTrackingSave === true;

              return (
                <EnhancedButtonPrimeReact
                  icon="pi pi-times"
                  severity={EnhancedButtonPrimeReactSeverity.Danger}
                  className="p-button-rounded p-button-text shadow-none bg-transparent delete-row-btn"
                  rounded
                  disabled={isDisabled}
                  onClickHandler={handler}
                />
              );
            }}
          />} */}
          {(hasNewRows || hasApiRows) && (
            <Column
              body={(rowData: any) => {
                const handler = getRowDeleteHandler(rowData);
                if (!handler) return null;
                const isDisabled = rowData.categoryTrackingSave === true;
                return (
                  <EnhancedButtonPrimeReact
                    icon="pi pi-times"
                    severity={EnhancedButtonPrimeReactSeverity.Danger}
                    className="p-button-rounded p-button-text shadow-none bg-transparent delete-row-btn"
                    rounded
                    disabled={isDisabled}
                    onClickHandler={handler}
                  />
                );
              }}
            />
          )}
        </DataTable>
      </div>
    </>
  );
};
